"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

/* eslint-disable */
var _default = /*#__PURE__*/React.createElement("svg", {
  width: "14",
  height: "14",
  viewBox: "0 0 32 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    display: 'inline-block',
    width: '1em',
    height: '1em',
    verticalAlign: 'middle',
    userSelect: 'none'
  }
}, /*#__PURE__*/React.createElement("path", {
  d: "M29.8898 11.9746H10.5878C9.97461 11.9746 9.4776 12.6575 9.4776 13.5C9.4776 14.3425 9.97461 15.0254 10.5878 15.0254H29.8898C30.503 15.0254 31 14.3425 31 13.5C31 12.6575 30.503 11.9746 29.8898 11.9746Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.8898 0.533875H10.5878C9.97461 0.533875 9.4776 1.21681 9.4776 2.0593C9.4776 2.90179 9.97461 3.58472 10.5878 3.58472H29.8898C30.503 3.58472 31 2.90179 31 2.0593C31 1.21681 30.503 0.533875 29.8898 0.533875Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.8898 23.4153H10.5878C9.97461 23.4153 9.4776 24.0982 9.4776 24.9407C9.4776 25.7832 9.97461 26.4661 10.5878 26.4661H29.8898C30.503 26.4661 31 25.7832 31 24.9407C31 24.0982 30.503 23.4153 29.8898 23.4153Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.05932 4.11864C3.19665 4.11864 4.11864 3.19665 4.11864 2.05932C4.11864 0.92199 3.19665 0 2.05932 0C0.92199 0 0 0.92199 0 2.05932C0 3.19665 0.92199 4.11864 2.05932 4.11864Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.05932 15.5593C3.19665 15.5593 4.11864 14.6373 4.11864 13.5C4.11864 12.3627 3.19665 11.4407 2.05932 11.4407C0.92199 11.4407 0 12.3627 0 13.5C0 14.6373 0.92199 15.5593 2.05932 15.5593Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.05932 27C3.19665 27 4.11864 26.078 4.11864 24.9407C4.11864 23.8033 3.19665 22.8813 2.05932 22.8813C0.92199 22.8813 0 23.8033 0 24.9407C0 26.078 0.92199 27 2.05932 27Z",
  fill: "black"
}));

exports["default"] = _default;
//# sourceMappingURL=unorderedList.js.map